import { render, staticRenderFns } from "./data-entry-button.vue?vue&type=template&id=42e6960f&scoped=true&"
import script from "./data-entry-button.vue?vue&type=script&lang=js&"
export * from "./data-entry-button.vue?vue&type=script&lang=js&"
import style0 from "./data-entry-button.vue?vue&type=style&index=0&id=42e6960f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42e6960f",
  null
  
)

export default component.exports